"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Therapy = void 0;
var Therapy;
(function (Therapy) {
    Therapy[Therapy["NN"] = 0] = "NN";
    Therapy[Therapy["PE"] = 1] = "PE";
    Therapy[Therapy["EE"] = 2] = "EE";
    Therapy[Therapy["STO"] = 3] = "STO";
    Therapy[Therapy["TS"] = 4] = "TS";
    Therapy[Therapy["INKO"] = 5] = "INKO";
    Therapy[Therapy["WV"] = 6] = "WV";
    Therapy[Therapy["IV"] = 7] = "IV";
    Therapy[Therapy["BEA"] = 8] = "BEA";
    Therapy[Therapy["SON"] = 9] = "SON";
    Therapy[Therapy["OSA"] = 10] = "OSA";
    Therapy[Therapy["HH"] = 11] = "HH";
    Therapy[Therapy["ABS"] = 12] = "ABS";
    Therapy[Therapy["PUE"] = 13] = "PUE";
    Therapy[Therapy["SS"] = 14] = "SS";
    Therapy[Therapy["IUA"] = 15] = "IUA";
    Therapy[Therapy["LHM"] = 16] = "LHM";
    Therapy[Therapy["ST"] = 17] = "ST";
    Therapy[Therapy["IT"] = 18] = "IT";
    Therapy[Therapy["RH"] = 19] = "RH";
    Therapy[Therapy["BEF"] = 20] = "BEF";
    Therapy[Therapy["HF"] = 21] = "HF";
    Therapy[Therapy["AT"] = 22] = "AT";
    Therapy[Therapy["MON"] = 23] = "MON";
    Therapy[Therapy["DIA"] = 24] = "DIA";
    Therapy[Therapy["ZS"] = 25] = "ZS";
    Therapy[Therapy["SSB"] = 26] = "SSB";
    Therapy[Therapy["ORTHO"] = 27] = "ORTHO";
    Therapy[Therapy["REHA"] = 28] = "REHA";
    Therapy[Therapy["ESTI"] = 29] = "ESTI";
    Therapy[Therapy["DM"] = 30] = "DM";
    Therapy[Therapy["APPAIDS"] = 31] = "APPAIDS";
    Therapy[Therapy["MEADEV"] = 32] = "MEADEV";
    Therapy[Therapy["PCA"] = 33] = "PCA";
    Therapy[Therapy["AMG"] = 34] = "AMG";
    Therapy[Therapy["DV"] = 35] = "DV";
    Therapy[Therapy["SI"] = 36] = "SI";
    Therapy[Therapy["TN"] = 37] = "TN";
    Therapy[Therapy["SL"] = 38] = "SL";
    Therapy[Therapy["MT"] = 39] = "MT";
    Therapy[Therapy["TNO"] = 40] = "TNO";
    Therapy[Therapy["ASEPT"] = 41] = "ASEPT";
    Therapy[Therapy["AKT"] = 42] = "AKT";
    Therapy[Therapy["Cross"] = -1] = "Cross";
})(Therapy = exports.Therapy || (exports.Therapy = {}));
exports.default = Therapy;
